<template>
  <div>
    <!-- Content -->
    <div class="mb-xxl">
      <p class="has-text-weight-bold mb-md">API Account Credentials</p>
      <div class="mb-md">
        Your API account &amp; Client credentials are below:
      </div>
      <div class="rounded-lg">
        <!-- Loading -->
        <div v-if="loading && client === null">
          <loading message="Loading client..." />
        </div>
        <div v-else>
          <div>
            <p class="has-text-weight-bold">Brand ID</p>
            <p>{{ context.partner.id }}</p>
            <p class="has-text-weight-bold">Client Name</p>
            <p>{{ client.name }}</p>
            <p class="has-text-weight-bold">Client ID</p>
            <p>{{ client.client_id }}</p>
            <p class="is-size-7">
              <a href="#" class="has-text-info" @click.prevent v-clipboard:copy="account.client_id"
                v-clipboard:success="copied">Copy</a>
            </p>
          </div>
          <div>
            <p class="has-text-weight-bold">Client Secret</p>
            <p v-if="!client.secret_retrieved_at">
              <a href="#" @click.prevent="showSecretModal = true" class="has-text-info has-text-weight-bold">
                Get Client Secret
              </a>
            </p>
            <p v-else class="has-text-grey-light">
              Client secret was retrieved on {{ $dates.utc(client.secret_retrieved_at).local().format('MMM D, YYYY') }}.
              If you need access to this secret, please please file a
              <a href="#" @click.prevent="$store.dispatch('supportRequest')" class="has-text-info">support request</a>
              for assistance.
            </p>
          </div>
        </div>
        <p class="mt-xl mb-md">
          You API credentials has been configured according to your preferences.
          You may revisit this configuration at any time by visiting your
          <router-link :to="{ name: 'client', params: { id: account.id } }" class="has-text-info">API Client
            settings.</router-link>
        </p>
      </div>

    </div>
    <!-- Navigate -->
    <div class="py-lg">
      <div class="columns is-centered">
        <div class="column">
          <b-button type="is-light rounded-lg" size="is-medium" @click="goBack" expanded><b-icon
              icon="arrow-left"></b-icon>
          </b-button>
        </div>
        <div class="column">
          <b-button type="is-primary rounded-lg" size="is-medium" expanded @click="goForward" :disabled="saving"
            :loading="saving">Complete Task</b-button>
        </div>
      </div>
    </div>
    <!-- Secret Modal -->
    <b-modal :has-modal-card="true" :active.sync="showSecretModal" :can-cancel="['x']">
      <ClientSecretModal :client="client" @secret:retrieved="load(true)" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClientSecretModal from '@/components/Models/User/Modals/ClientSecret'

export default {
  components: {
    ClientSecretModal
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return this.context.route + '/users/' + this.account.id + '/'
    }
  },
  data () {
    return {
      saving: false,
      loading: true,
      client: null,
      showSecretModal: false
    }
  },
  methods: {
    goBack () {
      this.$emit('navigate', 'Intro')
    },
    goForward () {
      this.saving = true
      const endpoint = this.context.route + '/assigned-tasks/' + this.task.id + '/complete/'
      this.$http.put(endpoint).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Task Completed!' })
        this.$router.push({ name: 'onboarding.tasks', params: { connection: this.connection.id } })
      }).catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again!' })
      }).finally(() => {
        this.saving = false
      })
    },
    copied () {
      this.$buefy.toast.open({ type: 'is-success', message: 'Copied!' })
    },
    load (silent) {
      if (!silent) this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.client = response.data
        this.loading = false
      })
    }
  },
  mounted () {
    this.load()
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    account: {
      type: Object,
      required: true
    }
  }
}
</script>
